<script>
import vue2Dropzone from "vue2-dropzone";
import Vue from "vue";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import firebase from "firebase/compat/app";
import { functions } from "../main";
import "firebase/firestore";
import "firebase/functions";
import Profile from "../components/Profile/Profile.vue";
import _ from "lodash";
import DeclineBookingDialog from "../components/declineBookingDialog.vue";
import RatingDialog from "../components/RatingDialog.vue";
import ItemQualityDialog from "../components/ItemQualityDialog.vue";
import RatingItemDialog from "../components/RatingItemDialog.vue";
import LoginComponent from "@/components/Auth/Login";
import SignupComponent from "@/components/Auth/Signup";

new Vue({
  beforeCreate: function () {
    console.log("dash state: ", this.$dashState);
  },
});

const uuid = require("uuid");

export default {
  props: ["s"],
  name: "Reviews",
  metaInfo: {
    title: "Reviews",
    titleTemplate: "Strapp - Reviews 📊",
    content:
      "An online rental marketplace where you can rent out your household items and equipment to others for short term periods.",
    htmlAttrs: { lang: "en" },
    meta: [
      { charset: "utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
    ],
  },

  data() {
    return {
      state: "listings",
      reviewState: "user",
      bookingState: "pending",
      returnedState: "past-borrowed",
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 200,
        // maxFilesize: 0.5,
        addRemoveLinks: true,
        dictDefaultMessage: `<p class='text-default'><i class='fa fa-cloud-upload mr-2'></i> Drag Images or Click Here</p>
          `,
        headers: { "My-Awesome-Header": "header value" },
      },
      rating: 0,
      review: "",
      max: 500,
      rateSuccessDialog: false,
      booking: {},
      dialog: false,
      dialog1: false,
      verifyDialog: true,
      itemQualityDialog: false,
      rateUserDialog: false,
      rateItemDialog: false,
      show1: false,
      refreshKey: false,
      show2: false,
      editPdialog: false,
      acceptedDialog: false,
      fab: false,
      snackbar: false,
      text: ``,
      stateData: "",
      photo: "",
      userId: "",
      name: "",
      loadedItems: [],
      loadedBookings: [],
      declineBookingDialog: false,
      email: "",
      loginDialog: false,
      rateSuccessDialog: false,
      signupDialog: false,
      editedEmail: "",
      password: "",
      verified: false,
      confirmPassword: "",
      recievedPendingMenu: false,
      cards: ["Today", "Yesterday"],
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => v.length >= 8 || "Min 8 characters",
        emailMatch: () => "The email and password you entered don't match",
      },
    };
  },

  components: {
    Profile,
    LoginComponent,
    SignupComponent,
    Loader: () => import("@/components/Loader.vue"),
    vueDropzone: vue2Dropzone,
    DeclineBookingDialog,
    RatingDialog,
    ItemQualityDialog,
    RatingItemDialog,
  },

  created() {
    this.$store.dispatch("loadBookings");

    firebase.auth().onAuthStateChanged((user) => {
      this.authUser = user;
      if (user) {
        this.displayName = user.displayName;
        if (this.photoURL) {
          this.photoURL = user.photoURL;
        }
        this.email = user.email;
        this.userId = user.uid;
      } else {
        this.loginDialog = true;
      }
    });
    console.log("created state: ", this.stateData);
    console.log("s: ", this.s);
    if (this.s != undefined) {
      console.log("requestedBookings");
      this.state = "bookings-received";
      this.s = Number(this.s) + 1;
    } else {
      this.s = 1;
    }

    Vue.prototype.$dashState = "listedItems";
  },

  mounted() {
    this.stateData = this.$route.params;
    console.log("state is", this.stateData);
    console.log("data state is", this.s);
  },

  watch: {
    user(value) {
      if (value !== null && value !== undefined) {
        this.$emit("loggedIn");
      }
    },
    $route() {
      this.loadParam();
    },
  },

  computed: {
    reviews() {
      console.log("all reviews: ", this.$store.getters.loadedReviews);
      return this.$store.getters.loadedReviews.filter(
        (review) =>
          review.borrowerID === this.userId && review.reviewType === "user"
      );
    },

    size() {
      const size = { xs: "x-small", sm: "medium", lg: "large", xl: "large" }[
        this.$vuetify.breakpoint.name
      ];
      return size ? { [size]: true } : {};
    },

    itemReviews() {
      console.log("all reviews: ", this.$store.getters.loadedReviews);
      return this.$store.getters.loadedReviews.filter(
        (review) =>
          review.lenderID === this.userId && review.reviewType === "item"
      );
    },

    reviewAvg() {
      let sum = 0;
      let count = 0;
      this.reviews.forEach((review) => {
        sum += review.rating;
        count++;
      });
      // if (reviews.length === 0){
      //   this.reviewState = 'item'
      // }
      if (sum === 0) {
        return 0;
      } else {
        return Math.round((sum / count) * 100) / 100;
      }
    },

    itemReviewAvg() {
      let sum1 = 0;
      let count1 = 0;
      this.items.forEach((item) => {
        if (item.rating != undefined) {
          sum1 += item.rating * item.rating_count;
          count1 = count1 + Number(item.rating_count);
        }
      });
      console.log(sum1, count1);
      if (sum1 === 0) {
        return 0;
      } else {
        return Math.round((sum1 / count1) * 100) / 100;
      }
    },

    size() {
      const size = { xs: "x-small", sm: "medium", lg: "medium", xl: "medium" }[
        this.$vuetify.breakpoint.name
      ];
      return size ? { [size]: true } : {};
    },

    loading() {
      return this.$store.getters.loading;
    },

    items() {
      return this.$store.getters.loadedItems.filter((item) => {
        return item.userID === this.userId;
      });
    },

    returned() {
      console.log("returned", this.$store.getters.loadedBookings);
      return this.$store.getters.loadedBookings.filter((booking) => {
        return (
          ((booking.lenderID === this.userId ||
            booking.borrowerID === this.userId) &&
            booking.status === "complete") ||
          ((booking.lenderID === this.userId ||
            booking.borrowerID === this.userId) &&
            booking.status === "returnedL") ||
          booking.status === "returnedB" ||
          (booking.status === "returned" &&
            (booking.lenderID === this.userId ||
              booking.borrowerID === this.userId)) ||
          (booking.status === "awaiting-deposit" &&
            (booking.borrowerID === this.userId ||
              booking.lenderID === this.userId))
        );
      });
    },

    bookingsPlacedReturned() {
      return this.$store.getters.loadedBookings.filter((booking) => {
        return (
          (booking.borrowerID === this.userId &&
            booking.status === "returned") ||
          (booking.borrowerID === this.userId && booking.status === "returnedL")
        );
      });
    },

    bookingsReceivedReturned() {
      console.log("bookings returned", this.$store.getters.loadedBookings);
      return this.$store.getters.loadedBookings.filter((booking) => {
        return (
          (booking.lenderID === this.userId && booking.status === "returned") ||
          (booking.lenderID === this.userId && booking.status === "returnedB")
        );
      });
    },

    bookingsAwaitingImages() {
      return this.$store.getters.loadedBookings.filter((booking) => {
        return (
          booking.lenderID === this.userId &&
          booking.status === "awaiting-images"
        );
      });
    },

    // bookingsReceivedCompleted() {
    //   return this.$store.getters.loadedBookings.filter((booking) => {
    //     return (
    //       (booking.status === 'complete' && booking.lenderID === this.userId) ||  (booking.status === 'returnedL' && booking.lenderID === this.userId) ||(booking.status === 'awaiting-deposit' && (booking.lenderID === this.userId))
    //     );
    //   });
    // },

    bookingsPlacedCompleted() {
      return this.$store.getters.loadedBookings.filter((booking) => {
        return (
          (booking.status === "complete" &&
            booking.borrowerID === this.userId) ||
          (booking.status === "returnedB" && booking.borrowerID === this.userId)
        );
      });
    },

    bookingsPlacedAwaitingDeposit() {
      return this.$store.getters.loadedBookings.filter((booking) => {
        return (
          (booking.status === "awaiting-deposit" &&
            booking.borrowerID === this.userId) ||
          (booking.status === "returnedB" &&
            booking.borrowerID === this.userId &&
            booking.deposit != undefined)
        );
      });
    },

    completed() {
      return this.$store.getters.loadedBookings.filter((booking) => {
        return (
          (booking.status === "complete" &&
            (booking.lenderID === this.userId ||
              booking.borrowerID === this.userId)) ||
          (booking.status === "returnedB" &&
            booking.borrowerID === this.userId &&
            booking.deposit === undefined) ||
          (booking.status === "returnedL" &&
            booking.lenderID === this.userId) ||
          (booking.status === "awaiting-deposit" &&
            booking.lenderID === this.userId)
        );
      });
    },

    bookingsPlaced() {
      return this.$store.getters.loadedBookings.filter((booking) => {
        return (
          booking.borrowerID === this.userId &&
          booking.status !== "returned" &&
          booking.status !== "returnedL" &&
          booking.status !== "returnedB" &&
          booking.status !== "complete" &&
          booking.status !== "awaiting-deposit"
        );
      });
    },
    bookingsPlacedPending() {
      return this.$store.getters.loadedBookings.filter((booking) => {
        return (
          booking.borrowerID === this.userId && booking.status === "pending"
        );
      });
    },
    bookingsPlacedAwaitingPayment() {
      this.refreshKey;
      return this.$store.getters.loadedBookings.filter((booking) => {
        return (
          booking.borrowerID === this.userId &&
          booking.status === "awaiting-payment"
        );
      });
    },
    bookingsPlacedActive() {
      this.refreshKey;
      return this.$store.getters.loadedBookings.filter((booking) => {
        return (
          booking.borrowerID === this.userId && booking.status === "active"
        );
      });
    },

    bookingsPlacedFinalised() {
      return this.$store.getters.loadedBookings.filter((booking) => {
        return (
          (booking.borrowerID === this.userId &&
            booking.status === "finalised") ||
          (booking.borrowerID === this.userId &&
            booking.status === "awaiting-images")
        );
      });
    },

    bookingsPlacedDeclined() {
      return this.$store.getters.loadedBookings.filter((booking) => {
        return (
          booking.borrowerID === this.userId && booking.status === "declined"
        );
      });
    },

    bookingsPlacedOverdue() {
      return this.$store.getters.loadedBookings.filter((booking) => {
        return (
          booking.borrowerID === this.userId && booking.status === "overdue"
        );
      });
    },

    bookingsPlacedCompleted() {
      return this.$store.getters.loadedBookings.filter((booking) => {
        return (
          (booking.status === "complete" &&
            booking.borrowerID === this.userId) ||
          (booking.status === "returnedB" && booking.borrowerID === this.userId)
        );
      });
    },

    bookingsPlacedCancelled() {
      return this.$store.getters.loadedBookings.filter((booking) => {
        return (
          booking.borrowerID === this.userId && booking.status === "cancelled"
        );
      });
    },

    bookingsReceived() {
      console.log("bookings received: ", this.$store.getters.loadedBookings);
      this.refreshKey;
      return this.$store.getters.loadedBookings.filter((booking) => {
        console.log("getter");
        return (
          booking.lenderID === this.userId &&
          booking.status !== "complete" &&
          booking.status !== "returned" &&
          booking.status !== "returnedL" &&
          booking.status !== "returnedB" &&
          booking.status !== "awaiting-deposit"
        );
      });
    },

    bookingsReceivedAwaitingPayment() {
      console.log("bookings awaiting payment");
      this.refreshKey;
      return this.$store.getters.loadedBookings.filter((booking) => {
        return (
          booking.lenderID === this.userId &&
          booking.status === "awaiting-payment"
        );
      });
    },
    bookingsReceivedPending() {
      console.log("bookings pending");
      this.refreshKey;
      return this.$store.getters.loadedBookings.filter((booking) => {
        return booking.lenderID === this.userId && booking.status === "pending";
      });
    },
    bookingsReceivedActive() {
      this.refreshKey;
      return this.$store.getters.loadedBookings.filter((booking) => {
        return booking.lenderID === this.userId && booking.status === "active";
      });
    },

    bookingsReceivedFinalised() {
      return this.$store.getters.loadedBookings.filter((booking) => {
        return (
          (booking.lenderID === this.userId &&
            booking.status === "finalised") ||
          (booking.lenderID === this.userId &&
            booking.status === "awaiting-images")
        );
      });
    },

    bookingsReceivedCompleted() {
      return this.$store.getters.loadedBookings.filter((booking) => {
        return (
          (booking.status === "complete" && booking.lenderID === this.userId) ||
          (booking.status === "returnedL" &&
            booking.lenderID === this.userId) ||
          (booking.lenderID === this.userId &&
            booking.status === "awaiting-deposit")
        );
      });
    },

    bookingsReceivedCancelled() {
      return this.$store.getters.loadedBookings.filter((booking) => {
        return (
          booking.lenderID === this.userId && booking.status === "cancelled"
        );
      });
    },

    bookingsReceivedOverDue() {
      return this.$store.getters.loadedBookings.filter((booking) => {
        return booking.lenderID === this.userId && booking.status === "overdue";
      });
    },
  },

  methods: {
    changeState: function (newState) {
      this.state = newState;
    },
    changeReviewState: function (newState) {
      this.reviewState = newState;
    },
    changeBookingState: function (newState) {
      this.bookingState = newState;
    },
    changeReturnedState: function (newState) {
      this.returnedState = newState;
    },
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 20;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },

    showToast(msg) {
      console.log("fire toast");
      this.snackbar = true;
      this.text = msg;
    },

    loadParam() {
      console.log("params changes");
      this.$router.go();
    },
    refresh() {
      this.$router.push("/reviews").catch((err) => {});
    },
    reload() {
      //  Vue.prototype.$dashState = 'bookingsReceived'
      // // this.$store.commit('loadBookings');
      // //  this.$store.dispatch('loadedBooking')
      //   //  this.$store.dispatch('loadBookings');
      //    this.$router.go()
      // this.$store.replaceState()
      // console.log('reload')
      //  this.refreshKey = !this.refreshKey;
      let data = {
        state: "requests",
      };
      //   this.$router.push('/dashboard?s='+ this.s).catch(err => {})
      // {
      //       name: "Dashboard 📊", //use name for router push
      //       params: { data: 'requests' },
      //       query: { s: '1' }
      //     }
      //   )
    },

    onSaveChanges() {
      Toast.fire({
        title: "Account preferences updated successfully!",
      });
      this.dialog1 = false;
    },

    onLogout() {
      this.$store.dispatch("logout");
      this.$router.push("/");
    },

    acceptBooking(booking) {
      // console.log(booking);
      console.log(booking);

      try {
        var addMessage = firebase
          .functions()
          .httpsCallable("bookingRequestAccepted");
        addMessage({
          email: booking.borrowerEmail,
          id: booking.id,
          borrowerName: booking.borrowerName,
          itemName: booking.itemName,
        });
      } catch (e) {
        const errorMessage = error.message;
        alert(errorMessage);
      }
      try {
        var bookingRef = firebase
          .firestore()
          .collection("bookings")
          .doc(booking.id);

        bookingRef.update({
          status: "awaiting-payment",
          updatedAt: new Date(),
        });
      } catch (e) {
        const errorMessage = error.message;
        alert(errorMessage);
      } finally {
        this.acceptedDialog = true;
      }
    },

    firestore() {
      const user = fb.auth().currentUser;
      return {
        profile: db.collection("users").doc(user.uid),
      };
    },
  },
};
</script>
<template>
  <div class="ml-5">
    <v-dialog
      v-model="signupDialog"
      scrollable
      :overlay="false"
      max-width="568px"
      transition="dialog-transition"
    >
      <SignupComponent
        :shouldRedirect="false"
        @loggedIn="signupDialog = false"
        :fromPage="true"
        :addItem="false"
        :addBooking="false"
        @changeDialog="
          signupDialog = false;
          loginDialog = true;
        "
      />
    </v-dialog>

    <v-dialog
      v-model="loginDialog"
      scrollable
      persistent
      :overlay="false"
      max-width="568px"
      transition="dialog-transition"
    >
      <LoginComponent
        :shouldRedirect="false"
        :fromPage="true"
        :addItem="false"
        :addBooking="false"
        @loggedIn="loginDialog = false"
        @changeDialog="
          loginDialog = false;
          signupDialog = true;
        "
      />
    </v-dialog>

    <!-- <div v-if="loading">
      <v-row>
        <v-col cols="12" sm="4" md="3" lg="2">
          <v-skeleton-loader
            type="card-avatar, article, actions"
          ></v-skeleton-loader>
        </v-col>

        <v-col cols="12" sm="8" md="9" lg="10">
          <v-row class="grid">
            <div class="text-center mb-4">
              <h4
                :class="[$vuetify.breakpoint.mdAndUp ? 'headline' : 'headline']"
                class="text-center font-weight-bold"

              >
                My Reviews
              </h4>


            </div>
          </v-row>
          <v-row>
            <v-col cols="12" md="3">
              <v-skeleton-loader
                class="mx-auto"
                max-width="300"
                type="card"
              ></v-skeleton-loader>
              <v-skeleton-loader
                class="mx-auto"
                max-width="300"
                type="card"
              ></v-skeleton-loader>
            </v-col>

            <v-col cols="6" md="3">
              <v-skeleton-loader
                class="mx-auto"
                max-width="300"
                type="card"
              ></v-skeleton-loader>
              <v-skeleton-loader
                class="mx-auto"
                max-width="300"
                type="card"
              ></v-skeleton-loader>
            </v-col>
            <v-col cols="6" md="3">
              <v-skeleton-loader
                class="mx-auto"
                max-width="300"
                type="card"
              ></v-skeleton-loader>
              <v-skeleton-loader
                class="mx-auto"
                max-width="300"
                type="card"
              ></v-skeleton-loader>
            </v-col>
            <v-row> </v-row>

            <v-col cols="6" md="3">
              <v-skeleton-loader
                class="mx-auto"
                max-width="300"
                type="card"
              ></v-skeleton-loader>
              <v-skeleton-loader
                class="mx-auto"
                max-width="300"
                type="card"
              ></v-skeleton-loader>
            </v-col>

            <v-col cols="6" md="3">
              <v-skeleton-loader
                class="mx-auto"
                max-width="300"
                type="card"
              ></v-skeleton-loader>
              <v-skeleton-loader
                class="mx-auto"
                max-width="300"
                type="card"
              ></v-skeleton-loader>
            </v-col>
            <v-col cols="6" md="3">
              <v-skeleton-loader
                class="mx-auto"
                max-width="300"
                type="card"
              ></v-skeleton-loader>
              <v-skeleton-loader
                class="mx-auto"
                max-width="300"
                type="card"
              ></v-skeleton-loader>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div> -->

    <v-row v-if="!loading">
      <!-- <v-col class="fixed" cols="12" sm="4" md="3" lg="2">
        <profile
          @profileVerified="verified = $event"
          :isProfileVerified="verified"
        />
      </v-col> -->
      <v-col cols="12" sm="12" md="12" lg="12">
        
        <v-container>
           <v-icon color="black" @click="$router.go(-1)"
                >fas fa-arrow-left</v-icon
              > 
          <div class="text-center mb-4">
            <h4
              :class="[$vuetify.breakpoint.mdAndUp ? 'headline' : 'headline']"
              class="text-center font-weight-bold"
            >
              My Reviews
            </h4>
          </div>

          <!-- REVIEWS -->
          <template>
            <v-row>
              <v-btn
                v-bind="size"
                @click="changeReviewState('user')"
                :style="
                  reviewState === 'user'
                    ? 'border-bottom: 5px solid #B22AF0;'
                    : ''
                "
                text
                >From Lenders ({{ reviews.length }})</v-btn
              >
              <v-btn
                v-bind="size"
                @click="changeReviewState('item')"
                :style="
                  reviewState === 'item'
                    ? 'border-bottom: 5px solid #B22AF0;'
                    : ''
                "
                text
                >From Borrowers ({{ itemReviews.length }})</v-btn
              >
            </v-row>
            <!-- USER REVIEWS -->
            <template v-if="reviewState === 'user'">
              <v-row style="padding: 12px">
                <v-row v-if="reviews.length < 1" class="mb-2 grid mt-5">
                  <p class="text-h4 center">No reviews from lenders yet.</p>
              <p class="center"  >  When someone reviews their lending experience with you, it
                  will show up here.</p>
                  <v-img
                    width="150px"
                    height="150px"
                    :src="require('@/assets/svgs/astronaut.svg')"
                  />
                </v-row>
                <v-card
                  v-if="reviews.length >= 1"
                  class="pa-3"
                  style="
                    border-radius: 13px;
                    padding: 16px !important;
                    width: 100%;
                    max-height: 600px !important;
                    overflow-y: scroll;
                  "
                  elevation="4"
                >
                  <v-row
                    class="font-weight-bold h2"
                    style="
                      padding-top: 16px !important;
                      justify-content: center;
                    "
                  >
                    <!-- <div

                    style="
                      color: black;
                  text-align: center;
                  width: 100%;
                    "
                  > -->
                    <h3>Reviews From Lenders</h3>
                    <template v-if="reviewAvg >= 1">
                      <h3 style="margin-left: 32px !important">
                        Average Rating: {{ reviewAvg }}
                      </h3>
                      <svg
                        aria-hidden="true"
                        height="20px"
                        width="20px"
                        focusable="false"
                        data-prefix="fad"
                        data-icon="star"
                        class="svg-inline--fa fa-star mx-1"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 576 512"
                      >
                        <g class="fa-group">
                          <path
                            class="fa-secondary"
                            fill="gold"
                            d="M316.7 17.8l65.43 132.4l146.4 21.29c26.27 3.796 36.79 36.09 17.75 54.59l-105.9 102.1l25.05 145.5c4.508 26.31-23.23 45.9-46.49 33.7L288 439.6l-130.9 68.7C133.8 520.5 106.1 500.9 110.6 474.6l25.05-145.5L29.72 226.1c-19.03-18.5-8.516-50.79 17.75-54.59l146.4-21.29l65.43-132.4C271.1-6.083 305-5.786 316.7 17.8z"
                          ></path>
                          <path class="fa-primary" fill="gold" d=""></path>
                        </g>
                      </svg>
                    </template>
                  </v-row>
                  <v-row v-for="review in reviews" :key="review.id">
                    <!-- <v-col cols="12" lg="2" md="12"> -->

                    <!-- </v-col> -->
                    <!-- <v-col  cols="12" lg="6" md="12"> -->
                    <div
                      @click="$router.push('/profile/' + review.lenderID)"
                      class="font-weight-bold h2"
                      style="
                        color: black;
                        padding: 8px;
                        text-align: left;
                        justify: left;
                        width: 100%;
                        border-top: 1px solid #e0e0e0;
                        padding-top: 16px;
                      "
                    >
                      <v-row>
                        <v-col
                          style="padding: 4px"
                          cols="2"
                          lg="1"
                          xl="1"
                          md="2"
                        >
                          <v-avatar outline size="50">
                            <!-- <div > -->
                            <p class="hidden-sm-and-down hidden-md-and-up">
                              {{ review.reviewerAvatar }}
                            </p>
                            <v-img
                              v-if="review.reviewerAvatar != null"
                              :src="review.reviewerAvatar"
                            ></v-img>
                            <!-- </div> -->
                            <svg
                              v-else
                              viewBox="0 0 32 32"
                              xmlns="http://www.w3.org/2000/svg"
                              style="fill: currentcolor"
                              aria-hidden="true"
                              role="presentation"
                              focusable="false"
                            >
                              <path
                                d="m16 .7c-8.437 0-15.3 6.863-15.3 15.3s6.863 15.3 15.3 15.3 15.3-6.863 15.3-15.3-6.863-15.3-15.3-15.3zm0 28c-4.021 0-7.605-1.884-9.933-4.81a12.425 12.425 0 0 1 6.451-4.4 6.507 6.507 0 0 1 -3.018-5.49c0-3.584 2.916-6.5 6.5-6.5s6.5 2.916 6.5 6.5a6.513 6.513 0 0 1 -3.019 5.491 12.42 12.42 0 0 1 6.452 4.4c-2.328 2.925-5.912 4.809-9.933 4.809z"
                              ></path>
                            </svg>
                          </v-avatar>
                        </v-col>
                        <v-col
                          style="padding: 4px"
                          cols="7"
                          lg="8"
                          xl="8"
                          md="7"
                        >
                          <p
                            style="
                              float: center !important;
                              font-weight: normal;
                              color: black;
                              margin: 0px !important;
                              margin-left: 2px !important;
                            "
                          >
                            {{ review.lenderName }}
                          </p>

                          <v-rating
                            class="ma-4"
                            length="5"
                            readonly="{true}"
                            dense="{true}"
                            :value="review.rating"
                            color="yellow darken-2"
                            style="margin: 0px !important"
                          ></v-rating>
                        </v-col>
                        <v-col
                          style="padding: 4px"
                          cols="3"
                          lg="3"
                          xl="3"
                          md="3"
                        >
                          <p
                            style="
                              float: right;
                              font-weight: normal;
                              color: grey;
                            "
                          >
                            {{ review.date }}
                          </p>
                        </v-col>
                      </v-row>

                      <!-- <p class="hidden-sm-and-down hidden-md-and-up">
                      {{ strappDate }}
                    </p>
                    <p class="hidden-sm-and-down hidden-md-and-up">
                      {{ isVerified }}
                    </p> -->
                      <v-row>
                        <v-col
                          style="padding: 4px"
                          cols="2"
                          lg="1"
                          xl="1"
                          md="2"
                        ></v-col>
                        <v-col
                          style="padding: 4px"
                          cols="10"
                          lg="11"
                          xl="11"
                          md="10"
                        >
                          <h5
                            class="text"
                            style="
                              margin-left: 2px;
                              font-weight: normal !important;
                              color: black;
                            "
                          >
                            {{ review.review }}
                          </h5>
                        </v-col>
                      </v-row>
                    </div>
                  </v-row>

                  <!-- </v-col>
       <v-col cols="12" lg="4" md="12"> -->

                  <!-- </v-col> -->
                </v-card>
              </v-row>
            </template>

            <!-- ITEM REVIEWS -->
            <template v-if="reviewState === 'item'">
              <v-row style="padding: 12px">
                <v-row v-if="itemReviews.length < 1" class="mb-2 grid mt-5">
                  <p class="text-h4">No reviews from borrowers yet.</p>
                <p class="center">  When one of your items get a review, it will show up here.</p>
                  <v-img
                    width="150px"
                    height="150px"
                    :src="require('@/assets/svgs/astronaut.svg')"
                  />
                </v-row>
                <v-card
                  v-if="itemReviews.length >= 1"
                  class="pa-3"
                  style="
                    border-radius: 13px;
                    padding: 16px !important;
                    width: 100%;
                    max-height: 600px !important;
                    overflow-y: scroll;
                  "
                  elevation="4"
                >
                  <v-row
                    class="font-weight-bold h2"
                    style="
                      padding-top: 16px !important;
                      justify-content: center;
                    "
                  >
                    <!-- <div

                    style="
                      color: black;
                  text-align: center;
                  width: 100%;
                    "
                  > -->
                    <h3>Reviews From Borrowers</h3>
                    <template v-if="itemReviewAvg >= 1">
                      <h3 style="margin-left: 32px !important">
                        Average Rating: {{ itemReviewAvg }}
                      </h3>
                      <svg
                        aria-hidden="true"
                        height="20px"
                        width="20px"
                        focusable="false"
                        data-prefix="fad"
                        data-icon="star"
                        class="svg-inline--fa fa-star mx-1"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 576 512"
                      >
                        <g class="fa-group">
                          <path
                            class="fa-secondary"
                            fill="gold"
                            d="M316.7 17.8l65.43 132.4l146.4 21.29c26.27 3.796 36.79 36.09 17.75 54.59l-105.9 102.1l25.05 145.5c4.508 26.31-23.23 45.9-46.49 33.7L288 439.6l-130.9 68.7C133.8 520.5 106.1 500.9 110.6 474.6l25.05-145.5L29.72 226.1c-19.03-18.5-8.516-50.79 17.75-54.59l146.4-21.29l65.43-132.4C271.1-6.083 305-5.786 316.7 17.8z"
                          ></path>
                          <path class="fa-primary" fill="gold" d=""></path>
                        </g>
                      </svg>
                    </template>
                  </v-row>
                  <v-row v-for="review in itemReviews" :key="review.id">
                    <!-- <v-col cols="12" lg="2" md="12"> -->

                    <!-- </v-col> -->
                    <!-- <v-col  cols="12" lg="6" md="12"> -->
                    <div
                      @click="$router.push('/profile/' + review.borrowerID)"
                      class="font-weight-bold h2"
                      style="
                        color: black;
                        padding: 8px;
                        text-align: left;
                        justify: left;
                        width: 100%;
                        border-top: 1px solid #e0e0e0;
                        padding-top: 16px;
                      "
                    >
                      <v-row>
                        <v-col
                          style="padding: 4px"
                          cols="2"
                          lg="1"
                          xl="1"
                          md="2"
                        >
                          <v-avatar outline size="50">
                            <!-- <div > -->
                            <p class="hidden-sm-and-down hidden-md-and-up">
                              {{ review.reviewerAvatar }}
                            </p>
                            <v-img
                              v-if="review.reviewerAvatar != null"
                              :src="review.reviewerAvatar"
                            ></v-img>
                            <!-- </div> -->
                            <svg
                              v-else
                              viewBox="0 0 32 32"
                              xmlns="http://www.w3.org/2000/svg"
                              style="fill: currentcolor"
                              aria-hidden="true"
                              role="presentation"
                              focusable="false"
                            >
                              <path
                                d="m16 .7c-8.437 0-15.3 6.863-15.3 15.3s6.863 15.3 15.3 15.3 15.3-6.863 15.3-15.3-6.863-15.3-15.3-15.3zm0 28c-4.021 0-7.605-1.884-9.933-4.81a12.425 12.425 0 0 1 6.451-4.4 6.507 6.507 0 0 1 -3.018-5.49c0-3.584 2.916-6.5 6.5-6.5s6.5 2.916 6.5 6.5a6.513 6.513 0 0 1 -3.019 5.491 12.42 12.42 0 0 1 6.452 4.4c-2.328 2.925-5.912 4.809-9.933 4.809z"
                              ></path>
                            </svg>
                          </v-avatar>
                        </v-col>
                        <v-col
                          style="padding: 4px"
                          cols="7"
                          lg="8"
                          xl="8"
                          md="7"
                        >
                          <p
                            style="
                              float: center !important;
                              font-weight: normal;
                              color: black;
                              margin: 0px !important;
                              margin-left: 2px !important;
                            "
                          >
                            {{ review.borrowerName }} - {{ review.itemName }}
                          </p>

                          <v-rating
                            class="ma-4"
                            length="5"
                            readonly="{true}"
                            dense="{true}"
                            :value="review.rating"
                            color="yellow darken-2"
                            style="margin: 0px !important"
                          ></v-rating>
                        </v-col>
                        <v-col
                          style="padding: 4px"
                          cols="3"
                          lg="3"
                          xl="3"
                          md="3"
                        >
                          <p
                            style="
                              float: right;
                              font-weight: normal;
                              color: grey;
                            "
                          >
                            {{ review.date }}
                          </p>
                        </v-col>
                      </v-row>

                      <!-- <p class="hidden-sm-and-down hidden-md-and-up">
                      {{ strappDate }}
                    </p>
                    <p class="hidden-sm-and-down hidden-md-and-up">
                      {{ isVerified }}
                    </p> -->
                      <v-row>
                        <v-col
                          style="padding: 4px"
                          cols="2"
                          lg="1"
                          xl="1"
                          md="2"
                        ></v-col>
                        <v-col
                          style="padding: 4px"
                          cols="10"
                          lg="11"
                          xl="11"
                          md="10"
                        >
                          <h5
                            class="text"
                            style="
                              margin-left: 2px;
                              font-weight: normal !important;
                              color: black;
                            "
                          >
                            {{ review.review }}
                          </h5>
                        </v-col>
                      </v-row>
                    </div>
                  </v-row>

                  <!-- </v-col>
       <v-col cols="12" lg="4" md="12"> -->

                  <!-- </v-col> -->
                </v-card>
              </v-row>
            </template>
          </template>
        </v-container>
      </v-col>
    </v-row>

    <!-- QUALITY IMAGE DIALOG -->

    <!-- USER RATING DIALOG -->

    <!-- We really appreciate your feedback we will use it to improve our
              platform to better service you. We hope to get you amazing rental
              experiences in the future. -->
    <!-- END USER REVIEW -->

    <v-snackbar v-model="snackbar">
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
          Got it!
        </v-btn>
      </template>
    </v-snackbar>
    <!-- <v-dialog
      style="border-radius: 12px !important; overflow: hidden"
      v-model="yousureDialog"
      width="550"
    >
      <v-card
        style="border-radius: 12px !important; overflow: hidden"
        class="pa-3 text-center"
      >
        <v-card-title
          style="
            padding: 0px 24px !important;
            font-size: 1em !important;
            line-height: 1.43;
          "
          class="text-center black--text"
        >
          <v-icon small color="black" @click="acceptedDialog = false"
            >mdi-close</v-icon
          >
          <p class="my-3 ml-auto mr-auto">Booking Accepted! 🥳</p>
        </v-card-title>
        <v-divider></v-divider>
        <v-row>
          <v-col cols="12">
            <p class="pa-6">
              <span class="text-subtitle-2 font-weight-bold"
                >You have successfully accepted this booking!</span
              >
              <br /><br />
              Once we have verified received the payment from the borrower, we
              will send you a confirmation email. <br /><br />
              Until then this booking will have a status of 'Waiting for
              payment'
            </p>
          </v-col>
        </v-row>
        <div class="grid mt-n3">
          <v-btn class="appbutton mt-n3" @click="reload()">Continue</v-btn>
        </div>
      </v-card>
    </v-dialog> -->

    <v-btn
      v-scroll="onScroll"
      v-show="fab"
      fab
      dark
      fixed
      bottom
      right
      style="margin: 20px"
      color="primary"
      @click="toTop"
    >
      <v-icon>fas fa-angle-up</v-icon>
    </v-btn>
  </div>
</template>

<style scoped>
.borrowername:hover {
  color: #b22af0 !important;
}
.rounded {
  border-radius: 12px;
}
.grid {
  display: grid;
  place-items: center;
}

.Fixed {
  position: fixed;
  top: 20px;
}

.item {
  cursor: pointer;
}

.itmcrd {
  transition: opacity 0s ease-in-out;
}

.itmcrd:hover {
  opacity: 0.8;
}

.clip {
  text-overflow: clip;
  white-space: nowrap;
  width: 200px;
  overflow: hidden;
}

.card {
  border-color: rgb(221, 221, 221);
}

.card:hover {
  border-color: rgb(34, 34, 34);
}

.ebtn {
  display: inline-block;
  background: #7fc4a1;
  padding: 0.8rem 1.8rem;
  width: 25px;
  margin-top: 2rem;
  cursor: pointer;
  border-radius: 14px;
  font-weight: 700;
  transition: 0.5s;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease 0s;
}

.ebtn:hover {
  opacity: 0.8;
  border-radius: 18px;
  box-shadow: 0px 15px 20px rgba(46, 229, 157, 0.4);
  transform: translateY(-7px);
  color: #7552b9;
  background-color: #7552b9;
}

.add-button {
  padding: 1rem 4rem;
  border-radius: 100rem;
  font-weight: 700;
  transition: 0.5s;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease 0s;
}

.add-button:hover {
  box-shadow: 0px 15px 20px rgba(46, 229, 157, 0.4);
  transform: translateY(-7px);
}

.center {
  display: grid;
  place-items: center;
  justify-content: center;
  text-align: center;
}

.vbutton {
  padding: 1rem 4rem;
  border-radius: 100rem;
  font-weight: 700;
  transition: 0.5s;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease 0s;
  width: 12rem;
}

.vbutton:hover {
  color: #7552b9;
  background-color: #7552b9;
  box-shadow: 0px 15px 20px rgba(46, 229, 157, 0.4);
  transform: translateY(-7px);
  width: 13rem;
}

#wtf {
  background-color: #f0f2f5;
  height: 100vh;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}
@import url("https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css");
</style>
